import { OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { ListingComponent } from './listing/listing.component';

interface OffsetLimit {
  limit: number;
  offset: number;
}

export class ListingBaseComponent<RequestType extends OffsetLimit> implements OnInit {

  /**
   * Holds the loading state of this component
   */
  public loading = false;

  public showPaginator = true;

  public searchParameters: Partial<RequestType>;

  public filterParameters: Partial<RequestType> = {};

  protected refresh = new Subject<void>();
  @ViewChild(ListingComponent) protected listing: ListingComponent;

  public ngOnInit() {
    this.listing.currentPageChange.subscribe(page => {
      this.searchParameters.offset = (page - 1) * this.listing.currentLimit;

      this.refresh.next();
    });
    this.listing.currentLimitChange.subscribe(limit => {
      this.searchParameters.limit = limit;
      this.searchParameters.offset = 0;

      this.refresh.next();
    });
  }

  public applySearch(searchData) {
    this.filterParameters = {};
    if (searchData.value) {
      this.filterParameters[searchData.searchBy] = searchData.value;
    }
    if (searchData.valueStart) {
      this.filterParameters[searchData.searchBy + 'Inicial'] = searchData.valueStart;
    }
    if (searchData.valueEnd) {
      this.filterParameters[searchData.searchBy + 'Final'] = searchData.valueEnd;
    }

    this.refresh.next();
  }
}
